import { type AxiosResponse } from 'axios'

import { type CustomAxiosConfig } from '@/types/axios'
import { type BookingService } from '@/types/Booking'

import armSecureAxios from './secure-base'

export const fetchAllServices = async (config?: CustomAxiosConfig): Promise<AxiosResponse<BookingService[]>> => {
  return await armSecureAxios.get('/services/all', { ...config })
}

const bookingServiceArmService = {
  fetchAllServices
}

export default bookingServiceArmService
